/* eslint-disable no-nested-ternary */
const GROUP = {
  ACCOUNTING: 'accounting'
};

const GROUP_BY_ORDER_TASK_TYPE = {
  accounting: GROUP.ACCOUNTING,
  accounting_grow_and_scale: GROUP.ACCOUNTING,
  accounting_quick_start: GROUP.ACCOUNTING,
  accounting_up_and_running: GROUP.ACCOUNTING
};

const STATUS = {
  INACTIVE: 'inactive',
  PENDING: 'pending',
  ACTIVE: 'active'
};
const statusSortOrderByStatus = {
  inactive: 0,
  pending: 1,
  active: 2
};

const STATUS_BY_ORDER_TASK_STATUS = {
  canceled: STATUS.INACTIVE,
  cancelled: STATUS.INACTIVE,
  declined: STATUS.PENDING,
  incomplete: STATUS.PENDING,
  pending: STATUS.PENDING,
  processing: STATUS.PENDING,
  action_req: STATUS.PENDING,
  active: STATUS.ACTIVE,
  complete: STATUS.ACTIVE
};

const FRIENDLY_NAME_BY_ORDER_TASK_STATUS = (orderTaskType) => ({
  canceled: orderTaskType.includes('_plan_')
    ? 'Plan Canceled'
    : orderTaskType.includes('bundle')
      ? 'Bundle Canceled'
      : 'Canceled',
  cancelled: 'Canceled',
  declined: orderTaskType === 'banking' ? 'Declined' : 'Skipped',
  incomplete: 'Incomplete',
  pending: 'Order Received',
  processing: 'Processing',
  action_req: 'Client Action Required',
  active: orderTaskType.includes('_plan_')
    ? 'Plan Active'
    : orderTaskType.includes('bundle')
      ? 'Bundle Active'
      : 'Active',
  complete: 'Complete'
});

export const TASK_STATUS_DESCRIPTION = (orderTaskType) => ({
  processing: 'Your order has been submitted and is processing',
  pending: 'Our fulfillment team is reviewing your order',
  canceled: 'This item has been canceled',
  cancelled: 'This item has been canceled',
  incomplete: 'We need more information from you to proceed',
  action_req: 'We need more information from you to proceed',
  active: 'This service is active',
  complete: 'This item is complete',
  declined: orderTaskType === 'banking' ? 'Your application was declined' : 'Reach out to customer support to activate'
});

const wfgIRName = {
  AK: 'Initial Report',
  CA: 'First Statement of Information',
  CT: 'First Report',
  GA: 'Initial Report',
  MO: 'Initial Registration Report',
  NM: 'Initial Report'
};

export const getWfgIRName = (jurisdiction) => (
  wfgIRName[jurisdiction] || 'Initial Report'
);

export const getOrderTaskStatusFriendlyName = (orderTask) => (
  orderTask ? FRIENDLY_NAME_BY_ORDER_TASK_STATUS(orderTask.orderTaskType)[orderTask.orderTaskStatus] : 'Unknown'
);

export const getDerivedStatus = (orderTask) => (
  orderTask ? STATUS_BY_ORDER_TASK_STATUS[orderTask.orderTaskStatus] : STATUS.INACTIVE
);

export const sortOrderTaskByOrderTaskStatus = (orderTask1, orderTask2) => (
  statusSortOrderByStatus[getDerivedStatus(orderTask2)]
  - statusSortOrderByStatus[getDerivedStatus(orderTask1)]
);

/**
 * WARNING orderTasks are very complicated. There is no consistent behavior outside of
 * an orderTaskType. Below I am sorting to show active, pending then inactive in that order.
 * Post sorting we look for the first one we can find.
 *
 * @param {Array<object>} orderTasks
 * @param {string} findType
 * @returns {object}
 */
export const getOrderTaskByType = (orderTasks, findType) => {
  if (!orderTasks || orderTasks.length <= 0) {
    return null;
  }
  return orderTasks
    .sort(sortOrderTaskByOrderTaskStatus)
    .find(({ orderTaskType: type }) => (type === findType));
};

/**
 * WARNING orderTasks are very complicated. There is no consistent behavior outside of
 * an orderTaskType. Below I am sorting to show active, pending then inactive in that order.
 * Post sorting we look for the first one we can find.
 *
 * @param {Array<object>} orderTasks
 * @param {string} findGroup
 * @returns {object}
 */
export const getOrderTaskByGroup = (orderTasks, findGroup) => {
  if (!orderTasks || orderTasks.length <= 0) {
    return null;
  }
  return orderTasks
    .sort(sortOrderTaskByOrderTaskStatus)
    .find(({ orderTaskType: type }) => (GROUP_BY_ORDER_TASK_TYPE[type] === findGroup));
};

export const getDerivedStatusByType = (orderTasks, findType) => {
  if (!orderTasks || orderTasks.length <= 0) {
    return STATUS.INACTIVE;
  }

  return getDerivedStatus(getOrderTaskByType(orderTasks, findType));
};

export const getDerivedStatusByGroup = (orderTasks, findGroup) => {
  if (!orderTasks || orderTasks.length <= 0) {
    return STATUS.INACTIVE;
  }
  return getDerivedStatus(getOrderTaskByGroup(orderTasks, findGroup));
};

export const hasOrderTasksCorporateDocs = (orderTasks) => (
  orderTasks ? orderTasks.filter((order) => order.orderTaskType === 'corporate_docs').length > 0 : false
);
